import { render, staticRenderFns } from "./DrawerItem.vue?vue&type=template&id=3ae6e13c&scoped=true&"
import script from "./DrawerItem.vue?vue&type=script&lang=js&"
export * from "./DrawerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6e13c",
  null
  
)

export default component.exports